<template>
  <div class="recipes">
    <app-header display-search-action />
    <recipes-title-bar />
    <div class="loading" v-if="loading">
      <ag-loading />
    </div>
    <!-- <div class="filter-options">
      <category-select
        id="category-filter"
        :value="filter.category"
        @change="filterRecipes($event, 'category')"
      />
      <tag-select
        id="tag-filter"
        :value="filter.tag"
        @change="filterRecipes($event, 'tag')"
      />
    </div> -->
    <div class="error" v-if="error">
      Error loading recipes!
      <!-- TODO -->
    </div>
    <div v-else-if="filteredRecipes && filteredRecipes.length > 0">
      <ag-results
        :data="filteredRecipes"
        @view="onView"
      />
    </div>
    <empty-list class="empty-list" v-if="!filteredRecipes && !loading" entity-label="recipes" @add="onAdd">
      <book-open-icon />
    </empty-list>
  </div>
</template>

<!-- Location Type - Residence, Business, Apartment, etc? -->

<script>
  import { BookOpenIcon } from "vue-feather-icons";
  import EmptyList from "../../components/EmptyList";
  import AppHeader from "@/components/Header";
  import moment from "moment";
  import { mapState } from "vuex";
  // import CategorySelect from "./components/CategorySelect";
  // import TagSelect from "./components/TagSelect";
  import RecipesTitleBar from "./components/RecipesTitleBar";

  export default {
    name: "Recipes",
    data: () => ({
      loading: true,
      error: null, // TODO
      recipes: null,
      filter: {
        tag: null,
        category: null
      }
    }),
    computed: {
      ...mapState("user", ["isAuthenticated"]),
      ...mapState("recipes", ["withImagesOnly", "filterByCategory"]),
      filteredRecipes() {
        let filteredRecipes = this.recipes;
        if(filteredRecipes) {
          // Filter: Only show recipes with image
          if(this.withImagesOnly) {
            filteredRecipes = filteredRecipes.filter(recipe => recipe.imageUrl);
          }
          // Filter: By category
          if(this.filterByCategory && this.filterByCategory.categoryKey && this.filterByCategory.categoryKey !== "all") {
            filteredRecipes = filteredRecipes.filter(recipe => recipe.categoryKey === this.filterByCategory.categoryKey);
          }

        }
        return filteredRecipes;
      }
    },
    async mounted() {
      try {
        const result = await this.$service.recipe.findAll();

        if (!result) {
          return;
        }

        this.recipes = result.map(recipe => {
          const { updatedAt } = recipe;

          if (updatedAt) {
            recipe.updatedAt = moment(updatedAt).fromNow();
          }

          return recipe;
        });
      } catch (e) {
        console.error("Error loading recipes: ", e);
        this.error = true;
      }

      this.loading = false;
    },
    methods: {
      onAdd() {
        this.$router.push({
          name: "RecipeNew",
          params: { categoryKey: "new" }
        });
      },
      onView(recipe) {
        this.$router.push({
          name: "RecipeView",
          params: { categoryKey: recipe.categoryKey, key: recipe.key }
        });
      },
      filterRecipes(event, type) {
        console.log("event", event);
        console.log("type", type);
      }
    },
    components: { EmptyList, BookOpenIcon, AppHeader, RecipesTitleBar }
  };
</script>

<style scoped lang="scss">
  .recipes {
    height: 100%;

    .content {
      display: flex;
      flex-direction: column;
    }

    .loading {
      margin: 40px 0;
    }

    .empty-list {
      svg {
        color: rgba(0, 0, 0, 0.1);
      }
    }
  }
</style>
